export default "__VITE_ASSET__Bk1dPt_0__"